<template lang="pug">
v-container
  crud-scroll-details(
    ref="list"
    v-if="agreementsFiltered.length"
    :detailsComponent="detailsComponent"
    :adapter="adapter"
    :query="query"
    :queryField="{ label: 'Номер договора', key: 'search[number]' }"
  )
    template(#list-header-bottom="{ init, unSelect, resetSearch }")
      v-chip-group(
        v-model="selected"
        mandatory
      )
        v-chip(filter small color="secondary") все
        v-chip(filter color="secondary" small) требуют подписания

    template(#list-item="{ item }")
      v-list-item-avatar
        v-badge(
          dot overlap
          :value="item.chat ? item.chat.exists_unread_messages : false"
          color="error"
          offset-x="18"
          offset-y="18"
        )
          v-avatar
            v-icon(
            ) {{ item.users.length > 1 ? 'mdi-account-multiple' : 'mdi-account' }}
      v-list-item-content
        v-list-item-title {{ item.number }}
        v-list-item-subtitle
            v-chip(
              v-if="item.needToSign"
              color="warning" outlined small
            )
              v-icon(left small) mdi-alert
              | требуется подпись
      v-alert.mb-0(
        dense text
        :color="item.isPaymentPrePayment && item.is_active ? 'success' : 'error'"
      )
        .text-h6 {{ item.is_active ? `${item.paymentPercent} %` : 'Не активен' }}
  v-alert(v-else type="info") Нет ни одного типового договора
</template>

<script>
import CrudScrollDetails from '@/components/Global/crudScrollDetails/index.vue';
import ListDetail from './ListDetail.vue';

export default {
  components: {
    CrudScrollDetails,
  },
  props: {
    agreements: { type: Object, required: true },
  },
  data() {
    return {
      selected: 0,
      detailsComponent: {
        component: ListDetail,
        component_listeners: {
          unSelect: () => { this.$refs.list.unSelect(); this.$refs.list.refreshList(); },
        },
      },
    };
  },
  computed: {
    query() {
      const resulst = {
        ...this.selected ? { 'search[has_count_signature]': 1 } : {},
        ...this.$route.query.id ? {} : { 'search[is_active]': true },
      };
      return resulst;
    },
    agreementsFiltered() {
      return Object.values(this.agreements).filter((i) => !!i.id);
    },
  },
  watch: {
    agreementsFiltered: {
      handler(val) {
        if (val.length) {
          this.$nextTick(() => {
            if (this.$route.query.id) {
              this.selectById(this.$route.query.id);
              this.$router.replace({ query: { } });
            }
          });
        }
      },
      immediate: true,
    },
  },

  methods: {
    selectById(id) {
      this.$refs.list.selectById(id);
    },
    adapter(params) {
      const ids = this.agreementsFiltered.map((i) => i.id);
      return this.$api.contracts.getContractsModel({
        expand: 'users,transactions,qr_code,typical_contract_discount,typical_contract,preview_document,document,is_signed_executor,is_signed_customer',
        'search[typical_contract_id]': ids,

        sort: 'created_at',
        ...params,
      });
    },
  },
};
</script>
